import { cn } from '../../lib/styles';

interface DialogContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  state: 'open' | 'closed';
}

export function DialogContainer({ state, className, children, ...props }: DialogContainerProps) {
  return (
    <div
      data-slot="dialog-container"
      data-state={state}
      className={cn(
        'fixed top-[50%] left-[50%] z-401 grid w-fit translate-x-[-50%] translate-y-[-50%]',
        'data-[state=open]:animate-in data-[state=closed]:animate-out',
        'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
